
export class ProtocolNames {

	public static readonly Dns = "dns";
	public static readonly NetBios = "netbios";
	public static readonly Snmp = "snmp";
	public static readonly Wmi = "wmi";
	public static readonly Telnet = "telnet";
	public static readonly Ssh = "ssh";
	public static readonly Ping = "ping";
	public static readonly Vim = "vim";
	public static readonly Prtg = "prtg";
	public static readonly AWS = "aws";
	public static readonly HTTP = "http";

	public static DisplayName(protocolName: string): string {
		let displayName = "";

		switch (protocolName) {
			case ProtocolNames.Dns: displayName = "DNS"; break;
			case ProtocolNames.NetBios: displayName = "NetBIOS"; break;
			case ProtocolNames.Snmp: displayName = "SNMP"; break;
			case ProtocolNames.Wmi: displayName = "Windows/WMI"; break;
			case ProtocolNames.Telnet: displayName = "Telnet"; break;
			case ProtocolNames.Ssh: displayName = "SSH"; break;
			case ProtocolNames.Ping: displayName = "Ping/ICMP"; break;
			case ProtocolNames.Vim: displayName = "VMware"; break;
			case ProtocolNames.Prtg: displayName = "PRTG"; break;
			case ProtocolNames.AWS: displayName = "AWS"; break;
			case ProtocolNames.HTTP: displayName = "HTTP"; break;
		}

		return displayName;
	}

}

